import GraphEconomicIncomeValues from "./GraphEconomicIncomeValues";
import EconomicValue from "./EconomicValue";
import {IndicatorsGraphMock} from "../../../test/mock/CreditDataMock";
import Score from "./Score";
import {Person} from "../../../services/interface/query/person";
import {useFindChartFinanceSummaryService} from "../../../services/apis/apiDashboard";
import {useEffect, useState} from "react";
import {ChatFinanceDataInterface} from "../../../services/interface/query/dashboard/chat-finance-data-interface";
import GraphEconomicPredictionValues from "./GraphEconomicPredictionValues";
import {useTranslation} from "react-i18next";

interface Props {
    person?: Person;
}
const CreditData = ({person}:Props) => {
    const {t} = useTranslation("global");

    const {
        mutate: findFinanceSummaryService,
        isPending: loadingFinanceSummaryService,
        data: successFinanceSummaryService,
    } = useFindChartFinanceSummaryService();

    const [response, setResponse] = useState<ChatFinanceDataInterface | undefined>()

    useEffect(() => {
        if (person?.identification) {
            findFinanceSummaryService({identifier: person.identification, msj: `${t('assets')} ${t('income')} ${t('expenses')}`})
        }
    }, [person]);

    useEffect(() => {
        if (successFinanceSummaryService) {
            setResponse(successFinanceSummaryService);
        }
    }, [successFinanceSummaryService]);

    return (
        <div className={'flex lg:flex-row flex-col gap-3'}>
            <div className={'flex flex-col sm:flex-row lg:flex-col w-full lg:w-[25%] gap-2'}>
                <Score {...{person}}/>
                <div className={'flex flex-col w-full gap-2'}>
                    <EconomicValue loading={loadingFinanceSummaryService} type={'assets'} value={response?.totalAssets}/>
                    <EconomicValue loading={loadingFinanceSummaryService} type={'income'} value={response?.totalIncome}/>
                    <EconomicValue loading={loadingFinanceSummaryService} type={'expenses'} value={response?.totalExpenses}/>
                </div>
            </div>
            <div className={'flex flex-col w-full lg:w-[75%] gap-4'}>
                <GraphEconomicIncomeValues
                    indicators={IndicatorsGraphMock}
                    {...{person}}
                />
                <GraphEconomicPredictionValues/>
            </div>
        </div>
    )
}

export default CreditData
